
<div class="service"
     (click)="editService()"
>
  <div class="service__left">
    <div class="service__image">
      @if (service.image) {
        <app-image
          [src]="service.image"
          [alt]="service.name"
          preset="avatar"
          aspectRatio="1"
          [sizes]="'92px'"
          [width]="92"
          [height]="92"
        ></app-image>
      }
    </div>

    <div class="service__infos">
      <div class="service__title">
        <h2 class="service__name">{{service.name}}</h2>
      </div>

      <p class="service__price">
        {{service.price}}€
        @if (service.discountActive) {
          (-{{service.discount}}%)
        }
      </p>

      <div class="service__description"
           [innerHTML]="getFormattedServiceDescription(service)"
      ></div>
    </div>

    <div class="service__online-status service__online-status--{{(service.online ? 'online': 'offline')}}">
      <p>{{('services.item.status.' + (service.online ? 'online': 'offline'))|transloco}}</p>
    </div>
  </div>

  <div class="service__right">
    <i class="fa-solid fa-chevron-right"></i>
  </div>
</div>
